import _head from 'lodash/head';

import couponService from '../services/validateCoupon';

import {
    COUPON_GET,
    COUPON_ADD,
    COUPON_ADD_ERROR,
    COUPON_REMOVE,
    CART_SHOULD_UPDATE_TOTALS,
    CART_ADD
} from '../actions/actionTypes';

const couponMiddleware = store => next => action => {

    next(action);

    if (action.type === COUPON_GET || action.type === CART_ADD) {
        const cart = store.getState().cart.byHash;
        let variants = [];

        for (let key in cart) {
            variants.push({
                variant: key,
                is_bundle: cart[key].content.is_bundle
            });
        }

        if (action.type === COUPON_GET) {
            const state = {
                'code': action.code,
                'variants': variants
            };
            store.dispatch(
                addCoupon(state)
            ).then(() =>
                store.dispatch({ type: CART_SHOULD_UPDATE_TOTALS })
            );
        }

        if (action.type === CART_ADD) {
            const id = _head(store.getState().coupon.byId);
    
            if (id){
                const state = {
                    'id': id,
                    'variants': variants
                };
                store.dispatch(
                    validateCoupon(state)
                ).then(() =>
                    store.dispatch({ type: CART_SHOULD_UPDATE_TOTALS })
                );
            }
        }
        
    }

    if (action.type === COUPON_REMOVE) {
        store.dispatch({ type: CART_SHOULD_UPDATE_TOTALS })
    }
};

function addCoupon(state) {
    return function (dispatch) {
        return couponService.create(state).then(
            data => dispatch({type: COUPON_ADD, id: data.id, payload: data}),
            error => dispatch({type: COUPON_ADD_ERROR, error})
        );
    };
}

function validateCoupon(state) {
    return function (dispatch) {
        return couponService.validate(state).then(
            data => dispatch({type: COUPON_ADD, id: data.id, payload: data}),
            error => {
            dispatch({type: COUPON_REMOVE, id: state.id});
            dispatch({type: COUPON_ADD_ERROR, error});
        }
        );
    };
}

export default couponMiddleware

